"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleMileageRatePerKm = exports.VehicleEnum = void 0;
var VehicleEnum;
(function (VehicleEnum) {
    VehicleEnum[VehicleEnum["CAR"] = 0] = "CAR";
    VehicleEnum[VehicleEnum["MOTORCYCLE"] = 1] = "MOTORCYCLE";
})(VehicleEnum || (exports.VehicleEnum = VehicleEnum = {}));
var VehicleMileageRatePerKm;
(function (VehicleMileageRatePerKm) {
    VehicleMileageRatePerKm[VehicleMileageRatePerKm["CAR"] = 0.3] = "CAR";
    VehicleMileageRatePerKm[VehicleMileageRatePerKm["MOTORCYCLE"] = 0.2] = "MOTORCYCLE";
})(VehicleMileageRatePerKm || (exports.VehicleMileageRatePerKm = VehicleMileageRatePerKm = {}));
